import './invalidword.css';

const Invalid: React.FC = () => {
    return(
        <div className="invalidcontainer">
            Invalid word!
        </div>
    );
}

export default Invalid;